<template>
  <div class="main print-no-padding areaList">
    <h2 class="is-print-hide title-area">
      <span class="main-title">大区设置</span>
    </h2>
    <el-breadcrumb class="breadcrumb" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/shopManagement' }">门店设置</el-breadcrumb-item>
      <el-breadcrumb-item>大区设置</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="box-card">
      <div class="btn-bar">
        <div class="setting btn global_common_button_goast" @click="$router.push('/shopManagement/area')">
          <span>+新增大区</span>
        </div>
      </div>
      <area-table
        :data="list"
        :total="total"
        :pageNo="pageNo"
        :pageSize="pageSize"
        :pageSizes="pageSizes"
        @handle-pageNo="handlePageNoChange"
        @handle-pageSize="handlePageSizeChange"
      />
    </el-card>
  </div>
</template>

<script>
import Fetch from '@/api';
import AreaTable from './components/AreaTable';

export default {
  name: 'areaList',
  components: {
    AreaTable
  },
  data() {
    return {
      list: [],
      total: 10,
      pageNo: 1,
      pageSize: 12,
      pageSizes: [12, 24, 36, 48]
    };
  },
  created() {
    this.init();
  },
  methods: {
    fetchAreaList(params) {
      return Fetch.queryAreaList({ ...params, needStore: 1, companyId: this.$store.getters.companyId }).then(
        ({ data, pageNo, pageSize, totalCount }) => {
          this.list = data;
          this.pageNo = pageNo;
          this.pageSize = pageSize;
          this.total = totalCount;
        }
      );
    },
    init() {
      this.fetchAreaList({ pageNo: 1, pageSize: 12 });
    },
    handlePageNoChange(val) {
      const { pageSize } = this;
      this.fetchAreaList({
        pageNo: val,
        pageSize
      });
    },
    handlePageSizeChange(val) {
      const { pageNo } = this;
      this.fetchAreaList({
        pageNo,
        pageSize: val
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.breadcrumb {
  margin-bottom: 15px;
}

.btn-bar {
  margin-bottom: 15px;

  .btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 132px;
    height: 40px;
    font-size: 14px;
    border-radius: 4px;
    cursor: pointer;
  }
}
</style>
